<section class="user-customization">
  <header>
    <div>
      <span class="eyebrow">Открытый пользователь</span>
      <h1>Кастомизация</h1>
    </div>
    <button mat-stroked-button (click)="load()"><mat-icon>refresh</mat-icon> Обновить</button>
  </header>
  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <div class="layout">
    <aside class="preview-card">
      <span class="eyebrow">Предпросмотр профиля</span>
      <div
        class="profile-preview"
        [style.background-image]="
          selectedAsset('banner')?.imageUrl ? 'url(' + selectedAsset('banner')?.imageUrl + ')' : null
        "
      >
        <div class="shade"></div>
        <div class="identity">
          <div class="avatar-wrap">
            <img class="avatar" [src]="selectedAsset('avatar')?.imageUrl || user?.avatar" alt="Аватар" />
            <img
              *ngIf="selectedAsset('frame')?.imageUrl"
              class="frame"
              [src]="selectedAsset('frame')?.imageUrl"
              alt="Рамка"
            />
          </div>
          <div>
            <strong>{{ user?.name || 'Игрок' }}</strong
            ><span>ID {{ user?.fastId }}</span>
          </div>
        </div>
      </div>
      <p>Предпросмотр обновляется сразу, изменения применятся только после сохранения.</p>
    </aside>

    <main class="settings-card">
      <h2>Оформление профиля</h2>
      <div class="slot" *ngFor="let slot of slots">
        <div>
          <strong>{{ slot.label }}</strong
          ><span>{{ selectedAsset(slot.type)?.conditionText || 'Базовый вариант' }}</span>
        </div>
        <mat-form-field appearance="outline">
          <mat-select [(ngModel)]="selection[slot.type]">
            <mat-option [value]="null">Без системного оформления</mat-option>
            <mat-option *ngFor="let asset of assetsByType(slot.type)" [value]="asset.id">
              {{ asset.name }}{{ !asset.isEnabled ? ' (выключен)' : '' }}{{ asset.requiresGrant ? ' · по выдаче' : '' }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <button mat-raised-button color="primary" (click)="save()" [disabled]="saving || loading">
        {{ saving ? 'Сохранение…' : 'Сохранить оформление' }}
      </button>

      <mat-divider></mat-divider>
      <h2>Персонально выданные ассеты</h2>
      <div class="grant-form">
        <mat-form-field appearance="outline"
          ><mat-label>Ассет</mat-label
          ><mat-select [(ngModel)]="grantAssetId"
            ><mat-option *ngFor="let asset of grantCandidates()" [value]="asset.id"
              >{{ asset.name }} · {{ asset.type }}</mat-option
            ></mat-select
          ></mat-form-field
        >
        <mat-form-field appearance="outline"
          ><mat-label>Причина / комментарий</mat-label><input matInput [(ngModel)]="grantReason" maxlength="1000"
        /></mat-form-field>
        <button mat-raised-button color="accent" (click)="grant()" [disabled]="!grantAssetId">Выдать</button>
      </div>
      <div class="granted-list" *ngIf="state.granted.length; else noGrants">
        <div class="granted" *ngFor="let asset of state.granted">
          <img *ngIf="asset.imageUrl" [src]="asset.imageUrl" [alt]="asset.name" />
          <div>
            <strong>{{ asset.name }}</strong
            ><span>{{ asset.type }} · #{{ asset.id }}</span>
          </div>
          <button mat-icon-button color="warn" matTooltip="Отозвать" (click)="revoke(asset)">
            <mat-icon>remove_circle_outline</mat-icon>
          </button>
        </div>
      </div>
      <ng-template #noGrants><p class="empty">Пользователю пока ничего не выдавали.</p></ng-template>
    </main>
  </div>
</section>
